import React from "react";
import { FiEdit, FiTrash2, FiZoomIn } from "react-icons/fi";
import Tooltip from "../tooltip/Tooltip";
import { Link } from "react-router-dom";

const EditDeleteButton = ({
  id,
  title,
  tab,
  page,
  handleUpdate,
  handleModalOpen,
  days,
  percentage,
  isCheck,
  product,
  parent,
  children,
  hideDelete,
  hideEdit,
}) => {
  // const { t } = useTranslation();
  return (
    <>
      <div className="flex justify-center">
        {hideEdit && (
          <>
            {children?.length > 0 ? (
              <>
                <Link
                  to={`/categories/${parent?._id}`}
                  className="px-3 py-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
                >
                  <Tooltip
                    id="view"
                    Icon={FiZoomIn}
                    title="View"
                    bgColor="#10B981"
                  />
                </Link>

                <button
                  disabled={isCheck?.length > 0}
                  onClick={() => handleUpdate(id, days, percentage)}
                  className="px-3 py-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
                >
                  <Tooltip
                    id="edit"
                    Icon={FiEdit}
                    title="Edit"
                    bgColor="#10B981"
                  />
                </button>
              </>
            ) : (
              <>
                <button
                  disabled={isCheck?.length > 0}
                  onClick={() => handleUpdate(id, days, percentage)}
                  className="px-3 py-2 cursor-pointer text-gray-400 hover:text-green-600 focus:outline-none"
                >
                  <Tooltip
                    id="edit"
                    Icon={FiEdit}
                    title="Edit"
                    bgColor="#10B981"
                  />
                </button>
              </>
            )}
          </>
        )}

        {hideDelete &&
          (tab !== 3 ||
            (typeof tab === "undefined" &&
              (typeof page === "undefined" ||
                page === "driver" ||
                page === "vehicle"))) && (
            <button
              disabled={isCheck?.length > 0}
              onClick={() => handleModalOpen(id, title, product)}
              className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
            >
              <Tooltip
                id="delete"
                Icon={FiTrash2}
                title="Delete"
                bgColor="#EF4444"
              />
            </button>
          )}
      </div>
    </>
  );
};

export default EditDeleteButton;
